import toast from "react-hot-toast";
import { clientAPI } from "../client";
import { customDateFormatType } from "../../utils/utils";

export const attendanceSummaryCall = {
  chart: async (param) => {
    try {
      const options = {};

      if (param?.employeeId) options.employeeId = param.employeeId;

      if (param?.employeeType) options.employeeType = param.employeeType;

      if (param?.saleBlockId) options.saleBlockId = param.saleBlockId;
      if (param?.saleAreaId) options.saleAreaId = param.saleAreaId;
      if (param?.supportDepartmentId)
        options.supportDepartmentId = param.supportDepartmentId;
      if (param?.branchId) options.branchId = param.branchId;
      if (param?.department !== undefined && param?.department !== null)
        options.department = param.department; // 0|1|2

      // time filters
      if (param?.day) options.day = customDateFormatType(param.day);
      if (param?.month) options.month = param.month; // "MM-YYYY"
      if (param?.year) options.year = param.year;

      if (param?.startTime)
        options.startTime = customDateFormatType(param.startTime);
      if (param?.endTime) options.endTime = customDateFormatType(param.endTime);

      // statuses (optional)
      if (param?.registerStatus) options.registerStatus = param.registerStatus;
      if (param?.leaveStatus !== undefined && param?.leaveStatus !== null)
        options.leaveStatus = param.leaveStatus;

      if (param?.employeeStatus !== undefined && param?.employeeStatus !== null)
        options.employeeStatus = param.employeeStatus; // 0|1

      const queryParams = new URLSearchParams(options).toString();

      const response = await clientAPI(
        "get",
        `/checkin/attendance-summary?${queryParams}`
      );

      return response;
    } catch (error) {
      console.error("get chart error:", error);

      const errorMessages = error?.response?.data?.errors?.map(
        (err) => err.message
      ) || [
        error?.response?.data?.message ||
          error?.response?.statusText ||
          error?.message ||
          "An unexpected error occurred.",
      ];

      errorMessages.forEach((message) => toast.error(`${message}`));
      throw error;
    }
  },
};
